export const normalizeUsername = (value: string): string =>
  value.trim().toLowerCase();

export const isValidUsername = (value: string): boolean =>
  value.length > 0 && value.length <= 64;
